import { z } from "zod";
import { UserSimplified } from "src/models/UserSimplified";
import { Vote } from "src/models/Vote";

export const Kudos = z.object({
  recipients: UserSimplified.array(),
  vote: Vote,
  id: z.string(),
  description: z.string(),
  timestamp: z.number(),
});

export type Kudos = z.infer<typeof Kudos>;
